<template>
  <div class="financiero ps-4 pe-2 pt-4">
    <NavPill
      :options="navOptions"
      :activeTab="activeTab"
      @update:activeTab="activarPestana"
    />
    <div class="content mt-4 p-2">
      <!----------------------------------------- PESTAÑA DE VENTAS ----------------------------------->
      <div v-if="activeTab === 'Ventas'">
        <h3 class="mt-4">Ventas</h3>
        <p class="mt-6 text-lg text-analiza-dark mb-0 font-weight-bold">INDICADORES 2026</p>
        <p class="mt-1 text-lg text-analiza-dark font-weight-normal">Comparado con la farmacia en el mismo periodo del año anterior</p>

        <!-- INDICADORES SUPERIOR DE VENTAS -->
        <div class="row m-0">
          <div
            v-for="card in salesCardsVentas"
            :key="card.titulo"
            class="col-lg-3 col-sm-6 ps-2 pe-2"
          >
            <mini-statistics-card
              :title="card.titulo"
              :value="card.ventas"
              :valueOld="card.anterior"
              :percentage="card.incremento"
              :help="card.mensaje"
              :loading="ventasEstadisticasLoading"
            />
          </div>
          <div class="col-lg-3 col-sm-6"></div>
        </div>


        <p class="mt-8 mb-4 text-lg text-analiza-dark font-weight-bold">EVOLUCIÓN DE VENTAS ANUALES</p>

        <div class="row m-0 p-0">
          <div class="col-12 col-lg-6 mb-4 px-2">

            <div class="m-0" style="overflow:hidden">
                <optimiza-table 
                  id="ventas-anuales-table1"
                  title="Ventas totales:"
                  :cabecera="ventasAnualTotales.cabecera"
                  :lineas="ventasAnualTotales.lineas"
                  :loading="ventasAnualTablaLoading"
                />
            </div>

            <div class="m-0" style="overflow:hidden">
                <optimiza-table 
                  id="ventas-anuales-table2"
                  title="Ventas con seguro:"
                  :cabecera="ventasAnualSeguros.cabecera"
                  :lineas="ventasAnualSeguros.lineas"
                  :loading="ventasAnualTablaLoading"
                />
            </div>

            <div class="m-0" style="overflow:hidden">
                <optimiza-table 
                  id="ventas-anuales-table3"
                  title="Ventas libres:"
                  :cabecera="ventasAnualLibres.cabecera"
                  :lineas="ventasAnualLibres.lineas"
                  :loading="ventasAnualTablaLoading"
                />
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-4 px-2">
            <gradient-line-chart 
              id="chart-line"
              title="Evolución de ventas totales"
              description=""
              :chart="ventasAnualChart"
              :chart-colors="ventasAnualColores"
              :loading="ventasAnualTablaLoading"
              height="500"
            />
          </div>
        </div>

        <p class="mt-8 mb-4 text-lg text-analiza-dark font-weight-bold">EVOLUCIÓN DE VENTAS MENSUALES</p>

        <div class="row m-0 p-0">
          <div class="col-12 col-lg-4 mb-4 px-2">
                <optimiza-table 
                  id="ventas-mensuales-table"
                  title="Ventas totales:"
                  :cabecera="ventasMensualTotales.cabecera"
                  :lineas="ventasMensualTotales.lineas"
                  :loading="ventasMensualTablaLoading"
                />
          </div>

          <div class="col-12 col-lg-4 mb-4 px-2">
                <optimiza-table 
                  id="ventas-mensuales-table2"
                  title="Ventas con seguro:"
                  :cabecera="ventasMensualSeguros.cabecera"
                  :lineas="ventasMensualSeguros.lineas"
                  :loading="ventasMensualTablaLoading"
                />
          </div>

          <div class="col-12 col-lg-4 mb-4 px-2">
                <optimiza-table 
                  id="ventas-mensuales-table3"
                  title="Ventas libres:"
                  :cabecera="ventasMensualLibres.cabecera"
                  :lineas="ventasMensualLibres.lineas"
                  :loading="ventasMensualTablaLoading"
                />
          </div>
        </div>


        <p class="mt-8 mb-4 text-lg text-analiza-dark font-weight-bold">VENTA LIBRE SOBRE VENTA TOTAL</p>

        <!-- GRAFICA ANUAL DE VENTAS LIBRES SOBRE TOTAL -->
        <div class="row m-0" style="overflow:hidden">
          <div
            v-for="(item, index) in ventasAnualDonut.datasets"
            :key="`ventas-donut-${index}`"
            class="col-12 col-lg-4 mb-4 px-2"
          >
            <div class="card" style="overflow: hidden;">
              <donut-chart 
                :id="`chart-donut-${index}`"
                :title="item.label || ''"
                :description="item.description || ''"
                :chart="item"
                :total="item.total || ''"
                :loading="ventasGraficaAnualVentasLibresLoading"
                :chart-colors="ventasAnualVentasLibresColores"
                height="250"
              />
            </div>
          </div>
        </div>


        <p class="mt-8 mb-4 text-lg text-analiza-dark font-weight-bold">VENTA SEGURO SOBRE VENTA TOTAL</p>

        <!-- GRAFICA ANUAL DE VENTAS SEGURO SOBRE TOTAL -->
        <div class="row m-0" style="overflow:hidden">
          <div
            v-for="(item, index) in ventasAnualDonut2.datasets"
            :key="`ventas-donut-${index}`"
            class="col-12 col-lg-4 mb-4 px-2"
          >
            <div class="card" style="overflow: hidden;">
              <donut-chart 
                :id="`chart-donut2-${index}`"
                :title="item.label || ''"
                :description="item.description || ''"
                :chart="item"
                :total="item.total || ''"
                :loading="ventasGraficaAnualVentasLibresLoading"
                :chart-colors="ventasAnualVentasLibresColores"
                height="250"
              />
            </div>
          </div>
        </div>
      </div>

      <!--------------------------------------------- PESTAÑA DE GASTOS ------------------------------>
      <div v-if="activeTab === 'Gastos'">
        <h3 class="mt-4">Gastos y compras</h3>
        <p class="mt-6 text-lg text-analiza-dark mb-0 font-weight-bold">INDICADORES 2026</p>
        <p class="mt-1 text-lg text-analiza-dark font-weight-normal">Comparado con la farmacia mismo periodo año anterior</p>

        <!-- INDICADORES SUPERIOR DE GASTOS -->
        <div class="row m-0">
          <div
            v-for="card in salesCardsGastos"
            :key="card.titulo"
            class="col-lg-3 col-sm-6 ps-2 pe-2"
          >
            <mini-statistics-card
              :title="card.titulo"
              :value="card.gastos"
              :valueOld="card.anterior"
              :percentage="card.incremento"
              :help="card.mensaje"
              :loading="gastosEstadisticasLoading"
              value-type="porcentaje"
            />
          </div>
          <div class="col-lg-3 col-sm-6"></div>
        </div>

        <p class="mt-8 mb-4 text-lg text-analiza-dark font-weight-bold">GASTOS GENERALES DESGLOSADOS</p>

        <!-- GRAFICA ANUAL DE DESGLOSE DE GASTOS -->
        <div class="card mx-2" style="background-color:var(--bs-gray-200);overflow:hidden;">
          <div class="row">
            <div
              v-for="(item, index) in gastosAnualDonut.datasets"
              :key="`gastos-donut-${index}`"
              class="col-12 col-sm-6 col-md-3 mb-4 px-4"
            >
              <donut-chart 
                :id="`chart-donut2-${index}`"
                :title="item.label || ''"
                description=""
                :chart="item"
                :total="item.total || ''"
                :loading="gastosGraficaAnualLoading"
                height="300"
                :chart-colors="coloresDonut"
                :show-legend="false"
              />                
            </div>
          </div>
          <div
            v-if="leyendaColoresDonut.length"
            id="legendColoresDonut"
            class="legend-colores-donut"
          >
            <div
              v-for="(item, index) in leyendaColoresDonut"
              :key="`legend-color-${index}`"
              class="legend-colores-donut__item mx-4"
            >
              <span
                class="legend-colores-donut__color"
                :style="{ backgroundColor: item.color }"
              ></span>
              <span class="legend-colores-donut__texto">{{ item.texto }}</span>
            </div>
          </div>
        </div>

        <!-- GRAFICA DE GASTOS POR PERIODOS -->
        <div class="row mt-8 mb-4 mx-0">
          <div class="col-6 col-md-7 col-xl-9">
            <p class="text-lg text-analiza-dark font-weight-bold mb-0">GASTOS</p>
          </div>
          <div class="col-6 col-md-5 col-xl-3">
            <soft-select
              id="sel-periodo-gastos"
              v-model="periodoGastos"
              name="sel-periodo-gastos"
              class="mb-0"
              :valores="[
                  {id:'A', nombre:'Anual'},{id:'T', nombre:'Trimestral'},
                  {id:'1T', nombre:'Primer Trimestre'},{id:'2T', nombre:'Segundo Trimestre'},
                  {id:'3T', nombre:'Tercer Trimestre'},{id:'4T', nombre:'Cuarto Trimestre'},
              ]"
              placeholder="Seleccione periodo"
              @change="procesarGraficaAnual3Gastos"
            />
          </div>
        </div>

        <div class="row m-0" style="overflow:hidden">
          <div class="col-12 ps-2 pe-2">
            <gradient-line-chart 
              id="chart-line3b"
              title="Gastos desglosados"
              description=""
              :chart="gastosAnual3Chart"
              :loading="gastosGraficaAnual3Loading"
              :chart-colors="gastosColores"
              char-type="bar"
              height="500"
            />
          </div>
        </div>

        <div class="row me-0 ms-0 mt-2" style="overflow:hidden">
          <div class="col-12 col-sm-6 ps-2 pe-2 mt-2">
            <gradient-line-chart 
              id="chart-ratio-personal-ventas"
              title="Ratio personal/ventas"
              description=""
              :chart="gastosAnual3aChart"
              :loading="gastosGraficaAnual3Loading"
              :chart-colors="gastosColores2"
              height="300"
              char-type="bar"
            />
          </div> 
          <div class="col-12 col-sm-6 ps-2 pe-2 mt-2">
            <gradient-line-chart 
              id="chart-gastos-generales"
              title="Gastos generales"
              description=""
              :chart="gastosAnual3bChart"
              :loading="gastosGraficaAnual3Loading"
              :chart-colors="gastosColores2"
              height="300"
              char-type="bar"
            />
          </div> 
        </div>

        <!-- GRAFICA DE COMPRAS POR PERIODOS -->
        <div class="row mt-8 mb-4 mx-0">
          <div class="col-6 col-md-7 col-xl-9">
            <p class="text-lg text-analiza-dark font-weight-bold mb-0">COMPRAS</p>
          </div>
          <div class="col-6 col-md-5 col-xl-3">
            <soft-select
              id="sel-periodo-compras"
              v-model="periodoCompras"
              name="sel-periodo-compras"
              class="mb-0"
              :valores="[
                  {id:'A', nombre:'Anual'},{id:'T', nombre:'Trimestral'},
                  {id:'1T', nombre:'Primer Trimestre'},{id:'2T', nombre:'Segundo Trimestre'},
                  {id:'3T', nombre:'Tercer Trimestre'},{id:'4T', nombre:'Cuarto Trimestre'},
              ]"
              placeholder="Seleccione periodo"
              @change="procesarGraficaAnualCompras"
            />
          </div>
        </div>

        <div class="row me-0 ms-0 mt-2" style="overflow:hidden">
          <div class="col-12 col-sm-6 ps-2 pe-2 mt-2">
            <gradient-line-chart 
              id="chart-ratio-compras-ventas"
              title="Ratio compras/ventas"
              description=""
              :chart="comprasAnual1Chart"
              :loading="comprasGraficaAnualLoading"
              :chart-colors="comprasColores"
              height="300"
              char-type="bar"
            />
          </div> 
          <div class="col-12 col-sm-6 ps-2 pe-2 mt-2">
            <gradient-line-chart 
              id="chart-compras-mercancia-vendida"
              title="Compras mercancía vendida"
              description=""
              :chart="comprasAnual2Chart"
              :loading="comprasGraficaAnualLoading"
              :chart-colors="comprasColores"
              height="300"
              char-type="bar"
            />
          </div> 
        </div>

        <!-- GRAFICA DE EXISTENCIAS POR PERIODOS -->
        <div class="row mt-8 mb-4 mx-0">
          <div class="col-6 col-md-7 col-xl-9">
            <p class="text-lg text-analiza-dark font-weight-bold mb-0">EXISTENCIAS</p>
          </div>
          <div class="col-6 col-md-5 col-xl-3">
            <soft-select
              id="sel-periodo-existencias"
              v-model="periodoExistencias"
              name="sel-periodo-existencias"
              class="mb-0"
              :valores="[
                  {id:'A', nombre:'Anual'},{id:'T', nombre:'Trimestral'},
                  {id:'1T', nombre:'Primer Trimestre'},{id:'2T', nombre:'Segundo Trimestre'},
                  {id:'3T', nombre:'Tercer Trimestre'},{id:'4T', nombre:'Cuarto Trimestre'},
              ]"
              placeholder="Seleccione periodo"
              @change="procesarGraficaAnualExistencias"
            />
          </div>
        </div>

        <div class="row me-0 ms-0 mt-2" style="overflow:hidden">
          <div class="col-12 col-sm-6 ps-2 pe-2 mt-2">
            <gradient-line-chart 
              id="chart-ratio-existencias-ventas"
              title="Ratio existencias/ventas"
              description=""
              :chart="existenciasAnual1Chart"
              :loading="existenciasGraficaAnualLoading"
              :chart-colors="existenciasColores"
              height="300"
              char-type="bar"
            />
          </div> 
          <div class="col-12 col-sm-6 ps-2 pe-2 mt-2">
            <gradient-line-chart 
              id="chart-existencias-finales"
              title="Existencias finales"
              description=""
              :chart="existenciasAnual2Chart"
              :loading="existenciasGraficaAnualLoading"
              :chart-colors="existenciasColores"
              height="300"
              char-type="bar"
            />
          </div> 
        </div>

        <p class="mt-8 mb-4 text-lg text-analiza-dark font-weight-bold">TOTAL FONDO COMERCIO</p>

        <div class="row m-0" style="overflow:hidden">
          <div class="col-12 ps-2 pe-2">
            <optimiza-table 
              id="rd-table2"
              title=""
              :cabecera="fondoComercio.cabecera"
              :lineas="fondoComercio.lineas"
              :loading="fondoComercioLoading"
            />
          </div> 
        </div>
      </div>

      <div v-if="activeTab === 'Personal'">
        <h3 class="mt-4">Personal</h3>
        <p class="mt-6 text-lg text-analiza-dark mb-0 font-weight-bold">INDICADORES 2026</p>
        <p class="mt-1 text-lg text-analiza-dark font-weight-normal">Comparado con la farmacia mismo periodo año anterior</p>

        <!-- INDICADORES SUPERIOR DE PERSONAL -->
        <div class="row m-0">
          <div
            v-for="card in salesCardsPersonal"
            :key="card.titulo"
            class="col-lg-3 col-sm-6 ps-2 pe-2"
          >
            <mini-statistics-card
              :title="card.titulo"
              :value="card.personal || card.ventas || card.gastos || card.valor"
              :valueOld="card.anterior"
              :percentage="card.incremento"
              :help="card.mensaje"
              :loading="personalEstadisticasLoading"
              value-type="porcentaje"
            />
          </div>
          <div class="col-lg-3 col-sm-6"></div>
        </div>

        <div class="row mt-8 mb-4 mx-0">
          <div class="col-6 col-md-7 col-xl-9">
            <p class="text-lg text-analiza-dark font-weight-bold mb-0">GASTOS GENERALES DESGLOSADOS</p>
          </div>
          <div class="col-6 col-md-5 col-xl-3">
            <soft-select
              id="sel-periodo-personal"
              v-model="periodoPersonal"
              name="sel-periodo-personal"
              class="mb-0"
              :valores="[
                  {id:'A', nombre:'Anual'},{id:'T', nombre:'Trimestral'},
                  {id:'1T', nombre:'Primer Trimestre'},{id:'2T', nombre:'Segundo Trimestre'},
                  {id:'3T', nombre:'Tercer Trimestre'},{id:'4T', nombre:'Cuarto Trimestre'},
              ]"
              placeholder="Seleccione periodo"
              @change="procesarGraficaAnualPersonal"
            />
          </div>
        </div>

        <div class="row me-0 ms-0 mt-2" style="overflow:hidden">
          <div class="col-12 col-sm-6 ps-2 pe-2 mt-2">
            <gradient-line-chart 
              id="chart-ratio-personal-ventas"
              title="Ratio personal/ventas"
              description=""
              :chart="personalAnualChart"
              :loading="personalGraficaAnualLoading"
              :chart-colors="personalColores"
              height="300"
              char-type="bar"
            />
          </div> 
          <div class="col-12 col-sm-6 ps-2 pe-2 mt-2">
            <gradient-line-chart 
              id="chart-gastos-generales"
              title="Gastos generales"
              description=""
              :chart="personalAnual2Chart"
              :loading="personalGraficaAnualLoading"
              :chart-colors="personalColores2"
              height="300"
              char-type="bar"
            />
          </div> 
        </div>

      </div>

      <div v-if="activeTab === 'Rentabilidad'">
        <h3 class="mt-4">Rentabilidad</h3>
        <p class="mt-6 text-lg text-analiza-dark mb-0 font-weight-bold">INDICADORES 2026</p>
        <p class="mt-1 text-lg text-analiza-dark font-weight-normal">Comparado con la farmacia mismo periodo año anterior</p>

        <!-- INDICADORES SUPERIOR DE RENTABILIDAD -->
        <div class="row m-0">
          <div
            v-for="card in salesCardsRentabilidad"
            :key="card.titulo"
            class="col-lg-3 col-sm-6 ps-2 pe-2"
          >
            <mini-statistics-card
              :title="card.titulo"
              :value="card.margen"
              :valueOld="card.anterior"
              :percentage="card.incremento"
              :help="card.mensaje"
              :loading="rentabilidadEstadisticasLoading"
              value-type="porcentaje"
            />
          </div>
        </div>

        <!-- GRAFICA DE MARGENES POR PERIODOS -->
        <div class="row mt-8 mb-4 mx-0">
          <div class="col-6 col-md-7 col-xl-9">
            <p class="text-lg text-analiza-dark font-weight-bold mb-0">EVOLUCIÓN MÁRGENES</p>
          </div>
          <div class="col-6 col-md-5 col-xl-3">
            <soft-select
              id="sel-periodo-margenes"
              v-model="periodoMargenes"
              name="sel-periodo-margenes"
              class="mb-0"
              :valores="[
                  {id:'A', nombre:'Anual'},{id:'T', nombre:'Trimestral'},
                  {id:'1T', nombre:'Primer Trimestre'},{id:'2T', nombre:'Segundo Trimestre'},
                  {id:'3T', nombre:'Tercer Trimestre'},{id:'4T', nombre:'Cuarto Trimestre'},
              ]"
              placeholder="Seleccione periodo"
              @change="procesarGraficaAnualMargenes"
            />
          </div>
        </div>
        
        <div class="row me-0 ms-0 mt-2 mb-4" style="overflow:hidden">
          <div class="col-12 col-sm-6 ps-2 pe-2 mt-2">
            <gradient-line-chart 
              id="chart-line-margen2"
              title="Margen bruto con RD"
              description=""
              :chart="margenesAnualChart"
              :loading="margenesGraficaAnualLoading"
              :chart-colors="margenesColores"
              height="300"
              char-type="bar"
            />
          </div> 
          <div class="col-12 col-sm-6 ps-2 pe-2 mt-2">
            <gradient-line-chart 
              id="chart-line-margen3"
              title="Margen bruto sin RD"
              description=""
              :chart="margenesAnual2Chart"
              :loading="margenesGraficaAnualLoading"
              :chart-colors="margenesColores"
              height="300"
              char-type="bar"
            />
          </div> 
        </div>
        
        <div class="row m-0" style="overflow:hidden">
          <div class="col-12 ps-2 pe-2">
            <gradient-line-chart 
              id="chart-line-margen1"
              title="Margen neto"
              description=""
              :chart="margenesAnual3Chart"
              :loading="margenesGraficaAnualLoading"
              :chart-colors="margenesColores"
              char-type="bar"
              height="500"
            />
          </div>
        </div>

        <p class="mt-8 text-lg text-analiza-dark mb-0 font-weight-bold">RENTABILIDAD DE NEGOCIO</p>
        <p class="mt-1 text-lg text-analiza-dark font-weight-normal">Comparado con la farmacia mismo periodo año anterior</p>

        <!-- GRAFICA DE RENTABILIDAD DE NEGOCIO POR PERIODOS -->
        <div class="row mt-4 mb-4 mx-0">
            <div
              v-for="card in salesCardsRentabilidad2"
              :key="card.titulo"
              class="col-lg-3 col-sm-6 ps-2 pe-2"
            >
              <mini-statistics-card
                :title="card.titulo"
                :value="card.margen"
                :valueOld="card.anterior"
                :percentage="card.incremento"
                :help="card.mensaje"
                :loading="rentabilidadEstadisticas2Loading"
                :value-type="card.tipo"
              />
            </div>
        </div>

        <div class="row mt-8 mb-4 mx-0">
          <div class="col-6 col-md-7 col-xl-9">
            <p class="text-lg text-analiza-dark font-weight-bold mb-0">EVOLUCIÓN RENTABILIDAD</p>
          </div>
          <div class="col-6 col-md-5 col-xl-3">
            <soft-select
              id="sel-periodo-rentabilidad-negocio"
              v-model="periodoRentabilidadNegocio"
              name="sel-periodo-rentabilidad-negocio"
              class="mb-0"
              :valores="[
                  {id:'A', nombre:'Anual'},{id:'T', nombre:'Trimestral'},
                  {id:'1T', nombre:'Primer Trimestre'},{id:'2T', nombre:'Segundo Trimestre'},
                  {id:'3T', nombre:'Tercer Trimestre'},{id:'4T', nombre:'Cuarto Trimestre'},
              ]"
              placeholder="Seleccione periodo"
              @change="procesarGraficaRentabilidadNegocio"
            />
          </div>
        </div>

        <div class="row me-0 ms-0 mt-2" style="overflow:hidden">
          <div class="col-12 col-lg-6 ps-2 pe-2 mt-2 mb-4">
            <gradient-line-chart 
              id="chart-line-rentabilidad-negocio1"
              title="Beneficio de explotación"
              description=""
              :chart="rentabilidadNegocioAnualChart"
              :loading="rentabilidadNegocioGraficaLoading"
              :chart-colors="rentabilidadNegocioColores"
              height="300"
              char-type="bar"
            />
          </div> 
          <div class="col-12 col-lg-6 ps-2 pe-2 mt-2 mb-4">
            <gradient-line-chart 
              id="chart-line-rentabilidad-negocio2"
              title="Ratio personal/ventas"
              description=""
              :chart="rentabilidadNegocioAnual2Chart"
              :loading="rentabilidadNegocioGraficaLoading"
              :chart-colors="rentabilidadNegocioColores"
              height="300"
              char-type="bar"
            />
          </div> 
          <div class="col-12 col-lg-6 ps-2 pe-2 mt-2 mb-4">
            <gradient-line-chart 
              id="chart-line-rentabilidad-negocio3"
              title="EBITDA"
              description=""
              :chart="rentabilidadNegocioAnual3Chart"
              :loading="rentabilidadNegocioGraficaLoading"
              :chart-colors="rentabilidadNegocioColores"
              height="300"
              char-type="bar"
            />
          </div> 
          <div class="col-12 col-lg-6 ps-2 pe-2 mt-2 mb-4">
            <gradient-line-chart 
              id="chart-line-rentabilidad-negocio4"
              title="EBITDA vs ventas"
              description=""
              :chart="rentabilidadNegocioAnual4Chart"
              :loading="rentabilidadNegocioGraficaLoading"
              :chart-colors="rentabilidadNegocioColores"
              height="300"
              char-type="bar"
            />
          </div> 
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import NavPill from "@/views/components/NavPill.vue";
import MiniStatisticsCard from "@/examples/Cards/MiniStatisticsCard.vue";
import GradientLineChart from "@/examples/Charts/GradientLineChart.vue";
import DonutChart from "@/examples/Charts/DonutChart.vue";
import OptimizaTable from "./components/OptimizaTable";
import SoftSelect from "@/components/SoftSelect.vue";
import {globalFunctionsMixin} from '@/mixins/globalFunctions.js';

export default {
  name: "Financiero",
  components: {
    NavPill,
    MiniStatisticsCard,
    GradientLineChart,
    OptimizaTable,
    DonutChart,
    SoftSelect
  },
  mixins: [globalFunctionsMixin],
  data() {
    return {
      activeTab: '',
      navOptions: ['Ventas', 'Gastos', 'Personal', 'Rentabilidad'],
      salesCardsVentas: [{},{},{}],
      salesCardsGastos: [{},{},{},{}],
      salesCardsPersonal: [{}],
      salesCardsRentabilidad: [{},{},{}],
      salesCardsRentabilidad2: [{},{},{}],
      ventasAnualTablaLoading: false,
      ventasMensualTablaLoading: false,
      ventasEstadisticasLoading: false,
      ventasGraficaAnualVentasLibresLoading: false,
      gastosEstadisticasLoading: false,
      personalEstadisticasLoading: false,
      rentabilidadEstadisticasLoading: false,
      rentabilidadEstadisticas2Loading: false,
      gastosGraficaAnualLoading: false,
      gastosGraficaAnual3Loading: false,
      comprasGraficaAnualLoading: false,
      existenciasGraficaAnualLoading: false,
      fondoComercioLoading: false,
      personalGraficaAnualLoading: false,
      margenesGraficaAnualLoading: false,
      rentabilidadNegocioGraficaLoading: false,
      ventasAnualChart: {labels:[], datasets:[]},
      ventasAnualColores: [],
      ventasAnualVentasLibresColores: [],
      gastosColores: [],
      gastosColores2: [],
      existenciasColores: [],
      comprasColores: [],
      personalColores: [],
      personalColores2: [],
      margenesColores: [],
      rentabilidadNegocioColores: [],
      ventasAnualTotales: {cabecera:[], lineas:[]},
      ventasAnualLibres: {cabecera:[], lineas:[]},
      ventasAnualSeguros: {cabecera:[], lineas:[]},
      ventasMensualTotales: {cabecera:[], lineas:[]},
      ventasMensualLibres: {cabecera:[], lineas:[]},
      ventasMensualSeguros: {cabecera:[], lineas:[]},

      ventasAnualDonut: {datasets:[{},{},{}]},
      ventasAnualDonut2: {datasets:[{},{},{}]},
      gastosAnualDonut: {datasets:[{},{},{},{}]},
      gastosAnual3Chart: {labels:[], datasets:[]},
      gastosAnual3aChart: {labels:[], datasets:[]},
      gastosAnual3bChart: {labels:[], datasets:[]},
      comprasAnual1Chart: {labels:[], datasets:[]},
      comprasAnual2Chart: {labels:[], datasets:[]},
      existenciasAnual1Chart: {labels:[], datasets:[]},
      existenciasAnual2Chart: {labels:[], datasets:[]},
      personalAnualChart: {labels:[], datasets:[]},
      personalAnual2Chart: {labels:[], datasets:[]},
      margenesAnualChart: {labels:[], datasets:[]},
      margenesAnual2Chart: {labels:[], datasets:[]},
      margenesAnual3Chart: {labels:[], datasets:[]},
      rentabilidadNegocioAnualChart: {labels:[], datasets:[]},
      rentabilidadNegocioAnual2Chart: {labels:[], datasets:[]},
      rentabilidadNegocioAnual3Chart: {labels:[], datasets:[]},
      rentabilidadNegocioAnual4Chart: {labels:[], datasets:[]},
      fondoComercio: {cabecera:[], lineas:[]},
      farmacia: {},
      periodoGastos: 'A',
      periodoCompras: 'A',
      periodoExistencias: 'A',
      periodoPersonal: 'A',
      periodoMargenes: 'A',
      periodoRentabilidadNegocio: 'A',
      coloresDonut: ['#304e80', '#6fb1c8', '#2f5f7f', '#7fa6b8', '#b7dbe6', '#8fc7bd', '#a8bfa3', '#d8c7a3', '#c98f76', '#8d99a6'],
      gastosAnualColores: [{color:'', gasto:''}]
    };
  },

  computed: {
    leyendaColoresDonut() {
      return Object.values(this.gastosAnualColores || {})
        .map((item) => {
          if (typeof item === "string") {
            return { color: item, texto: item };
          }

          return {
            color: item.color,
            texto: item.gasto || item.texto || item.label || item.nombre || "",
          };
        })
        .filter((item) => item.color && item.texto);
    },
  },

  methods: {
    activarPestana(pestana) {  console.log('Cambia pestaña', pestana);
      this.activeTab = pestana;

      if (pestana === 'Ventas') { 
        this.procesarEstadisticasVentas();
        this.procesarTablaAnualVentas();
        this.procesarTablaMensualVentas();
        this.procesarGraficaAnualVentasLibres();
      }

      if (pestana === 'Gastos') { 
        this.procesarEstadisticasGastos();
        this.procesarGraficaAnualGastos();
        this.procesarGraficaAnual3Gastos();
        this.procesarGraficaAnualCompras();
        this.procesarGraficaAnualExistencias();
        this.procesarGraficaFondoComercio();
      }

      if (pestana === 'Personal') {
        this.procesarEstadisticasPersonal();
        this.procesarGraficaAnualPersonal();
      }

      if (pestana === 'Rentabilidad') {
        this.procesarEstadisticasRentabilidad();
        this.procesarGraficaAnualMargenes();
        this.procesarEstadisticasRentabilidad2();
        this.procesarGraficaRentabilidadNegocio();
      }
    },

    procesarEstadisticasVentas() {   
      this.ventasEstadisticasLoading = true;
      this.$store.dispatch("farmacias/estadisticas", { tipo: 'ventas', grafica: 'resumen', IdFarmacia: this.farmacia.Id }).then((response) => {
          this.salesCardsVentas = []; 
          this.salesCardsVentas.push(response.data.totales);
          this.salesCardsVentas.push(response.data.seguros);
          this.salesCardsVentas.push(response.data.libres); 
      }).catch((error) => {
          console.log('Error Ventas1',error);
      }).finally(() => {
          this.ventasEstadisticasLoading = false;
      });
    },

    procesarTablaAnualVentas() {
      this.ventasAnualTablaLoading = true;
      this.$store.dispatch("farmacias/estadisticas", { tipo: 'ventas', grafica: 'anual', IdFarmacia: this.farmacia.Id }).then((response) => {
          this.ventasAnualTotales.cabecera = response.totales.cabecera; 
          this.ventasAnualTotales.lineas = response.totales.lineas;
          this.ventasAnualSeguros.cabecera = response.seguros.cabecera; 
          this.ventasAnualSeguros.lineas = response.seguros.lineas;
          this.ventasAnualLibres.cabecera = response.libres.cabecera; 
          this.ventasAnualLibres.lineas = response.libres.lineas;

          const chartData = response.ventas || response;
          this.ventasAnualChart = {
            labels: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'],
            datasets: chartData.dataset || [],
          };
          this.ventasAnualColores = chartData.colores || [];
      }).catch((error) => {
          console.log('Error Ventas2',error);
      }).finally(() => {
          this.ventasAnualTablaLoading = false;
      });
    },

    procesarTablaMensualVentas() {
      this.ventasMensualTablaLoading = true;
      this.$store.dispatch("farmacias/estadisticas", { tipo: 'ventas', grafica: 'mensual', IdFarmacia: this.farmacia.Id }).then((response) => {
          this.ventasMensualTotales.cabecera = response.totales.cabecera; 
          this.ventasMensualTotales.lineas = response.totales.lineas;
          this.ventasMensualSeguros.cabecera = response.seguros.cabecera; 
          this.ventasMensualSeguros.lineas = response.seguros.lineas;
          this.ventasMensualLibres.cabecera = response.libres.cabecera; 
          this.ventasMensualLibres.lineas = response.libres.lineas;
      }).catch((error) => {
          console.log('Error Ventas3',error);
      }).finally(() => {
          this.ventasMensualTablaLoading = false;
      });
    },

    
    procesarGraficaAnualVentasLibres() {   
      this.ventasGraficaAnualVentasLibresLoading = true;
      this.$store.dispatch("farmacias/estadisticas", { tipo: 'ventas', grafica: 'ventaslibres', IdFarmacia: this.farmacia.Id }).then((response) => {
          this.ventasAnualDonut = response.donut;
          this.ventasAnualDonut2 = response.donut2;
          this.ventasAnualVentasLibresColores = response.donut.colores || [];
      }).catch((error) => {
          console.log('Error Ventas2',error);
      }).finally(() => {
          this.ventasGraficaAnualVentasLibresLoading = false;
      });
    },

    procesarEstadisticasGastos() {   
      this.gastosEstadisticasLoading = true;
      this.$store.dispatch("farmacias/estadisticas", { tipo: 'gastos', grafica: 'resumen', IdFarmacia: this.farmacia.Id }).then((response) => {
          this.salesCardsGastos = []; 
          this.salesCardsGastos.push(response.data.gastos);
          this.salesCardsGastos.push(response.data.compras);
          this.salesCardsGastos.push(response.data.existencias);
      }).catch((error) => {
          console.log('Error Gastos1',error);
      }).finally(() => {
          this.gastosEstadisticasLoading = false;
      });
    },

    procesarEstadisticasPersonal() {
      this.personalEstadisticasLoading = true;
      this.$store.dispatch("farmacias/estadisticas", { tipo: 'personal', grafica: 'resumen', IdFarmacia: this.farmacia.Id }).then((response) => {
          this.salesCardsPersonal = [];
          this.salesCardsPersonal.push(response.data);
      }).catch((error) => {
          console.log('Error Personal1',error);
      }).finally(() => {
          this.personalEstadisticasLoading = false;
      });
    },

    procesarGraficaAnualGastos() {   
      this.gastosGraficaAnualLoading = true;
      this.$store.dispatch("farmacias/estadisticas", { tipo: 'gastos', grafica: 'anual', IdFarmacia: this.farmacia.Id, periodo: 'A' }).then((response) => {
          this.gastosAnualDonut = response.donut;  console.log('Tengo',this.gastosAnualDonut);
          this.gastosAnualColores = response.colores || [];
          this.coloresDonut = Object.values(this.gastosAnualColores)
            .map((color) => {
              return typeof color === "string" ? color : color.color;
            })
            .filter(Boolean);
      }).catch((error) => {
          console.log('Error gastos2',error);
      }).finally(() => {
          this.gastosGraficaAnualLoading = false;
      });
    },

    procesarGraficaAnual3Gastos() {   
      this.gastosGraficaAnual3Loading = true;
      this.$store.dispatch("farmacias/estadisticas", { tipo: 'gastos', grafica: 'anual', IdFarmacia: this.farmacia.Id, periodo: this.periodoGastos }).then((response) => {
          const chartData = response.data || response;
          this.gastosAnual3Chart = {
            labels: chartData.anos || [],
            datasets: chartData.dataset || [],
          };
          this.gastosAnual3aChart = {
            labels: chartData.anos || [],
            datasets: chartData.dataPersonal || [],
          };
          this.gastosAnual3bChart = {
            labels: chartData.anos || [],
            datasets: chartData.dataGenerales || [],
          };
          this.gastosColores = response.colores2 || [];
          this.gastosColores2 = response.colores3 || [];
      }).catch((error) => {
          console.log('Error Gastos3',error);
      }).finally(() => {
          this.gastosGraficaAnual3Loading = false;
      });
    },

    procesarGraficaAnualCompras() {
      this.comprasGraficaAnualLoading = true;
      this.$store.dispatch("farmacias/estadisticas", { tipo: 'compras', grafica: 'anual', IdFarmacia: this.farmacia.Id, periodo: this.periodoCompras }).then((response) => {
          const chartData = response.data || response;
          this.comprasAnual1Chart = {
            labels: chartData.anos || [],
            datasets: chartData.dataCompras || [],
          };
          this.comprasAnual2Chart = {
            labels: chartData.anos || [],
            datasets: chartData.dataMercancia || [],
          };
          this.comprasColores = response.colores || [];
      }).catch((error) => {
          console.log('Error Compras',error);
      }).finally(() => {
          this.comprasGraficaAnualLoading = false;
      });      
    },

    procesarGraficaAnualExistencias() {
      this.existenciasGraficaAnualLoading = true;
      this.$store.dispatch("farmacias/estadisticas", { tipo: 'existencias', grafica: 'anual', IdFarmacia: this.farmacia.Id, periodo: this.periodoCompras }).then((response) => {
          const chartData = response.data || response;
          this.existenciasAnual1Chart = {
            labels: chartData.anos || [],
            datasets: chartData.dataCompras || [],
          };
          this.existenciasAnual2Chart = {
            labels: chartData.anos || [],
            datasets: chartData.dataMercancia || [],
          };
          this.existenciasColores = response.colores || [];
      }).catch((error) => {
          console.log('Error Existencias',error);
      }).finally(() => {
          this.existenciasGraficaAnualLoading = false;
      });      
    },

    procesarGraficaFondoComercio() {   
      this.fondoComercioLoading = true;
      this.$store.dispatch("farmacias/estadisticas", { tipo: 'fondoComercio', grafica: 'anual', IdFarmacia: this.farmacia.Id }).then((response) => {
          this.fondoComercio.cabecera = response.cabecera;
          this.fondoComercio.lineas = response.lineas;
      }).catch((error) => {
          console.log('Error fondoComercio',error);
      }).finally(() => {
          this.fondoComercioLoading = false;
      });
    },

    procesarGraficaAnualPersonal() {   
      this.personalGraficaAnualLoading = true;
      this.$store.dispatch("farmacias/estadisticas", { tipo: 'personal', grafica: 'anual', IdFarmacia: this.farmacia.Id, periodo: this.periodoGastos }).then((response) => {
          const chartData = response.data || response;
          this.personalAnualChart = {
            labels: chartData.anos || [],
            datasets: chartData.dataPersonal || [],
          };
          this.personalAnual2Chart = {
            labels: chartData.anos || [],
            datasets: chartData.dataGenerales || [],
          };
          this.personalColores = response.colores || [];
          this.personalColores2 = response.colores2 || [];
      }).catch((error) => {
          console.log('Error Gastos3',error);
      }).finally(() => {
          this.personalGraficaAnualLoading = false;
      });
    },

    procesarEstadisticasRentabilidad() {   
      this.rentabilidadEstadisticasLoading = true;
      this.$store.dispatch("farmacias/estadisticas", { tipo: 'rentabilidad', grafica: 'resumen', IdFarmacia: this.farmacia.Id }).then((response) => {
          this.salesCardsRentabilidad = [
            response.data.margen1,
            response.data.margen2,
            response.data.margen3,
          ].filter(Boolean);
      }).catch((error) => {
          console.log('Error Rentabilidad 1',error);
      }).finally(() => {
          this.rentabilidadEstadisticasLoading = false;
      });
    },

    procesarGraficaAnualMargenes() {   
      this.margenesGraficaAnualLoading = true;
      this.$store.dispatch("farmacias/estadisticas", { tipo: 'rentabilidad', grafica: 'anual', IdFarmacia: this.farmacia.Id, periodo: this.periodoMargenes }).then((response) => {
          const chartData = response.data || response;
          this.margenesAnualChart = {
            labels: chartData.anos || [],
            datasets: chartData.dataMargen1 || [],
          };
          this.margenesAnual2Chart = {
            labels: chartData.anos || [],
            datasets: chartData.dataMargen2 || [],
          };
          this.margenesAnual3Chart = {
            labels: chartData.anos || [],
            datasets: chartData.dataMargen3 || [],
          };
          this.margenesColores = response.colores || [];
      }).catch((error) => {
          console.log('Error Margenes',error);
      }).finally(() => {
          this.margenesGraficaAnualLoading = false;
      });
    },

    procesarEstadisticasRentabilidad2() {   
      this.rentabilidadEstadisticas2Loading = true;
      this.$store.dispatch("farmacias/estadisticas", { tipo: 'rentabilidad', grafica: 'resumen2', IdFarmacia: this.farmacia.Id }).then((response) => {
          this.salesCardsRentabilidad2 = [
            response.data.margen1,
            response.data.margen2,
          ].filter(Boolean);
      }).catch((error) => {
          console.log('Error Rentabilidad 2',error);
      }).finally(() => {
          this.rentabilidadEstadisticas2Loading = false;
      });
    },

    procesarGraficaRentabilidadNegocio() {
      this.rentabilidadNegocioGraficaLoading = true;
      this.$store.dispatch("farmacias/estadisticas", { tipo: 'rentabilidad', grafica: 'negocio', IdFarmacia: this.farmacia.Id, periodo: this.periodoRentabilidadNegocio }).then((response) => {
          const chartData = response.data || response;
          const labels = chartData.anos || chartData.cabecera || [];

          this.rentabilidadNegocioAnualChart = {
            labels,
            datasets: chartData.dataRentabilidad1 || chartData.dataNegocio1 || chartData.dataMargen1 || [],
          };
          this.rentabilidadNegocioAnual2Chart = {
            labels,
            datasets: chartData.dataRentabilidad2 || chartData.dataNegocio2 || chartData.dataMargen2 || [],
          };
          this.rentabilidadNegocioAnual3Chart = {
            labels,
            datasets: chartData.dataRentabilidad3 || chartData.dataNegocio3 || chartData.dataMargen3 || [],
          };
          this.rentabilidadNegocioAnual4Chart = {
            labels,
            datasets: chartData.dataRentabilidad4 || chartData.dataNegocio4 || chartData.dataMargen4 || [],
          };
          this.rentabilidadNegocioColores = response.colores || chartData.colores || [];
      }).catch((error) => {
          console.log('Error Rentabilidad Negocio',error);
      }).finally(() => {
          this.rentabilidadNegocioGraficaLoading = false;
      });
    },
  },
  async mounted() {
    this.farmacia = await this.leerLocalStorage("datosFarmacia");
    this.activarPestana('Ventas');
  },
  async beforeMount() {
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
  },
};
</script>



<style lang="scss" scoped>
.financiero {
  .content {
    padding: 20px;
    background-color: #f8f9fa;
    border-radius: 8px;
  }

  .legend-colores-donut {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 14px 18px;
    padding: 0 1rem 1.5rem;
  }

  .legend-colores-donut__item {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: #333;
    font-family: "Nunito Sans", sans-serif;
    font-size: 13px;
  }

  .legend-colores-donut__color {
    width: 12px;
    height: 12px;
    flex: 0 0 12px;
    border-radius: 50%;
  }
}
</style>
